import script from "./DailyGoalSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyGoalSlider.vue?vue&type=script&setup=true&lang=ts"

import "./DailyGoalSlider.vue?vue&type=style&index=0&id=254290ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254290ee"]])

export default __exports__